const MESSAGES = {
  mostrarLinhas: 'Mostrar Linhas:',
};

export default MESSAGES;
